import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { Modal, ModalCloseButton } from "@air/primitive-modal";
import React, { memo } from "react";
import image from "~/assets/cat-in-box.svg";
export const AccountAnnouncementModal = /*#__PURE__*/ memo((param)=>{
    let { onClose, title, description, ctaProps, withCloseButton, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: true,
        onDismiss: onClose,
        ...restOfProps,
        children: [
            withCloseButton && /*#__PURE__*/ _jsx("header", {
                className: "flex justify-end",
                children: /*#__PURE__*/ _jsx(ModalCloseButton, {
                    className: "shrink-0",
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-6 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: image,
                            height: "150",
                            alt: "Unlock more storage image"
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-center text-24 font-semibold text-blue-10",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "px-6 text-center text-16 text-grey-11",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ _jsx(Button, {
                    appearance: "filled",
                    color: "blue",
                    size: "large",
                    asChild: true,
                    "data-testid": "ANNOUNCEMENT_MODAL_CTA",
                    children: /*#__PURE__*/ _jsx("a", {
                        ...ctaProps
                    })
                })
            })
        ]
    });
});
AccountAnnouncementModal.displayName = "AccountAnnouncementModal";
